export default __webpack_public_path__ + "static/media/img-press-release-corporate-update-new.924c90f5.jpg";